import { render, staticRenderFns } from "./SoftwareContractModal.vue?vue&type=template&id=496a7e1a&"
import script from "./SoftwareContractModal.vue?vue&type=script&lang=js&"
export * from "./SoftwareContractModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports